import * as React from 'react';
import { useRoutes, RouteObject } from 'react-router-dom';
import { CapVersionPageComponent } from '@cengage/cap-version-page-lib-react';
import {
  CapAuthenticationGuardComponent,
  CapAuthenticationLoginRequiredComponent,
  CapLogoutComponent,
} from '@cengage/cap-portal-authentication-lib-react';

import { ReportListingComponent } from './report-listing/report-listing.component';
import { InstructorCoursesComponent } from './instructor-courses/instructor-courses.component';
import { EnrollmentListComponent } from './instructor-courses/enrollment-list/enrollment-list.component';
import {
  useSendEventOnRouteChange,
  RoutingEventParams,
} from './app-routing.hooks';

const routes: RouteObject[] = [
  {
    path: '',
    element: (
      <CapAuthenticationGuardComponent element={<ReportListingComponent />} />
    ),
  },
  {
    path: 'report/:reportUri',
    element: (
      <CapAuthenticationGuardComponent element={<ReportListingComponent />} />
    ),
  },
  {
    path: 'instructor-courses',
    element: (
      <CapAuthenticationGuardComponent
        element={<InstructorCoursesComponent />}
      />
    ),
    children: [
      {
        path: ':courseUri',
        element: (
          <CapAuthenticationGuardComponent
            element={<EnrollmentListComponent />}
          />
        ),
      },
    ],
  },
  {
    path: 'version',
    element: (
      <CapAuthenticationGuardComponent element={<CapVersionPageComponent />} />
    ),
  },
  {
    path: 'logout',
    element: <CapLogoutComponent />,
  },
  {
    path: 'login-required',
    element: <CapAuthenticationLoginRequiredComponent />,
  },
];

export const routingEvents: Record<string, RoutingEventParams> = {
  '/': {
    eventName: 'ReportListingComponent',
  },
  '/report/:reportUri': {
    eventName: 'ReportListingComponent',
    tagsFromParams: ['reportUri'],
  },
  '/instructor-courses': {
    eventName: 'InstructorCoursesComponent',
  },
  '/instructor-courses/:courseUri': {
    eventName: 'EnrollmentListComponent',
    tagsFromParams: ['courseUri'],
  },
  '/version': {
    eventName: 'CapVersionPageComponent',
  },
  '/logout': {
    eventName: 'CapLogoutComponent',
  },
  '/login-required': {
    eventName: 'CapAuthenticationLoginRequiredComponent',
  },
};

export function AppRoutingModule() {
  const element = useRoutes(routes);

  useSendEventOnRouteChange(routes, routingEvents);

  return element;
}
